import styled from 'styled-components';
import { COLOR_GRAY_90 } from 'styles/variables/colors';

export const BoxContainer = styled.div`
  position: absolute;
  visibility: visible;
  bottom: calc(${(props) => `-${props.height}px`} - 3px);
`;

export const Box = styled.div`
  background: #ffffff;
  height: 61px;
  color: ${COLOR_GRAY_90};
  font-size: 14px;
  max-width: 114px;
  text-align: center;
  padding: 10px;
  border-radius: 4px;
  font-weight: 600;
  position: relative;
  z-index: 1;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  z-index: 1;

  &:hover {
    z-index: 10;

    & ${BoxContainer} {
      visibility: visible;
    }
  }
`;
